<template>
  <component :is="layout" v-if="route" :theme="referrer.toLowerCase()">
    <component
      :is="route.view"
      :query-username="username"
      :query-token="token"
      :query-return-url="returnUrl"
      v-bind="route.props || {}"
    ></component>
  </component>
  <div v-else>
    {{ $t('error.internalServerError') }}
  </div>
</template>

<script>
import { THEME_REALDANIA, THEME_UNDERVAERKER, THEME_JUBILAEUM } from './themes';
import routeHandler from './functions/routeHandler';
import { getQuery } from './functions/query';

export default {
  mixins: [routeHandler],
  data() {
    return {
      returnUrl: '',
      username: '',
      token: '',
      routes: [
        {
          pathname: '/account/login',
          view: () => import(/* webpackChunkName: "viewLogin" */ './views/Login.vue'),
          layout: () => import(/* webpackChunkName: "layoutBaselogin" */ './layouts/BaseLogin.vue'),
        },
        {
          pathname: '/account/resetpassword',
          view: () => import(/* webpackChunkName: "resetPassword" */ './views/Login.vue'),
          layout: () => import(/* webpackChunkName: "layoutBaselogin" */ './layouts/BaseLogin.vue'),
        },
        {
          pathname: '/account/createuser',
          view: () => import(/* webpackChunkName: "createUser" */ './views/CreateUser.vue'),
          props: { createUserType: 'normal', loginPage: '/account/login' },
          layout: () => import(/* webpackChunkName: "layoutBaselogin" */ './layouts/BaseLogin.vue'),
        },
        {
          pathname: '/account/createrealdaniamemberuser',
          view: () => import(/* webpackChunkName: "createUser" */ './views/CreateUser.vue'),
          props: { createUserType: 'realdania-member', loginPage: '/account/login' },
          layout: () => import(/* webpackChunkName: "layoutBaselogin" */ './layouts/BaseLogin.vue'),
        },
      ],
    };
  },
  mounted() {
    this.token = getQuery('token', false) || '';
    this.username = getQuery('username', true) || '';
    this.returnUrl = getQuery('ReturnUrl', false, false) || '';

    if (
      window.location.search.toString().indexOf('client_id=undervaerker_website') > -1 ||
      this.returnUrl.indexOf('client_id=undervaerker_website') > -1
    ) {
      this.referrer = THEME_UNDERVAERKER;
    } else if (
      window.location.search.toString().indexOf('client_id=jubilaeum_website') > -1 ||
      this.returnUrl.indexOf('client_id=jubilaeum_website') > -1
    ) {
      this.referrer = THEME_JUBILAEUM;
    }
  },
};
</script>
